module.exports = __webpack_public_path__ + "assets/img/028.d88220d5.png";